import fileDownload from 'js-file-download';
import AGREGAR_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO from '@/graphql/mutations/administracion/auditorias/respuestas/detalles/documentos/agregarAuditoriaInformeRespuestaDetalleDocumento.gql';
import REMOVER_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO from '@/graphql/mutations/administracion/auditorias/respuestas/detalles/documentos/removerAuditoriaInformeRespuestaDetalleDocumento.gql';
import AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS from '@/graphql/querys/administracion/auditorias/auditoriaInformeRespuestaDetalleDocumentos.gql';
import AUDITORIA_INFORME_RESPUESTAS from '@/graphql/querys/administracion/auditorias/auditoriaInformeRespuestas.gql';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  methods: {
    // Agregar Detalle Documento
    async mixAgregarDetalleDocumento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO,
          variables: {
            documento: this.documento,
          },
          update: (store, { data: { agregarAuditoriaInformeRespuestaDetalleDocumento } }) => {
            const query = {
              query: AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS,
              variables: {
                idAuditoriaInformeRespuestaDetalle: this.idDetalle,
              },
            };
            const { auditoriaInformeRespuestaDetalleDocumentos } = store.readQuery(query);
            const respuestaDetalleDocumentosCopia = auditoriaInformeRespuestaDetalleDocumentos
              .slice();
            respuestaDetalleDocumentosCopia.push(agregarAuditoriaInformeRespuestaDetalleDocumento);
            store.writeQuery({
              ...query,
              data: {
                auditoriaInformeRespuestaDetalleDocumentos:
                respuestaDetalleDocumentosCopia,
              },
            });
            this.mixAgregarDocumentosEnRespuestasDetalle(store,
              agregarAuditoriaInformeRespuestaDetalleDocumento);
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Detalle Documento
    async mixEliminarDetalleDocumento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO,
        variables: {
          id: this.detalleDocumentoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS,
            variables: {
              idAuditoriaInformeRespuestaDetalle: this.detalleDocumentoEliminar
                .idAuditoriaInformeRespuestaDetalle,
            },
          };
          const data = store.readQuery(query);
          const { auditoriaInformeRespuestaDetalleDocumentos } = data;
          const index = auditoriaInformeRespuestaDetalleDocumentos
            .findIndex((respuestaDetalleDocumento) => respuestaDetalleDocumento.id
              === this.detalleDocumentoEliminar.id);
          if (index !== -1) {
            auditoriaInformeRespuestaDetalleDocumentos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
          this.mixEliminarDocumentosEnRespuestasDetalle(store);
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixDescargarDocumento(documento) {
      this.descargandoArchivo = true;
      await this.axios.get(
        `${BASE_URL}/${documento.datosArchivo.public_key}`,
        {
          responseType: 'blob',
        },
      )
        .then((res) => {
          fileDownload(res.data, `${documento.nombre}`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.descargandoArchivo = false;
    },
    async mixAgregarDocumentosEnRespuestasDetalle(store, agregarDocumento) {
      const { idInforme } = this.$route.params;
      const { idRespuesta } = this;
      const query = {
        query: AUDITORIA_INFORME_RESPUESTAS,
        variables: { idInforme },
      };
      const { auditoriaInformeRespuestas } = store.readQuery(query);
      const auditoriaInformeRespuestasCopia = auditoriaInformeRespuestas.slice();
      const respuestaEncontrada = auditoriaInformeRespuestasCopia
        .find(({ id }) => id === idRespuesta);
      // Buscar el detalle específico y actualizar el documento
      const detalleEncontrado = respuestaEncontrada.detalles
        .find(({ id }) => id === this.idDetalle);
      // Actualiza el documento en el detalle encontrado
      if (detalleEncontrado) {
        detalleEncontrado.documentos.push(agregarDocumento);
      }
      const index = auditoriaInformeRespuestasCopia
        .findIndex(({ id }) => id === respuestaEncontrada.id);
      if (index !== -1) {
        auditoriaInformeRespuestasCopia.splice(index, 1, respuestaEncontrada);
      }
      store.writeQuery({
        ...query,
        data: {
          auditoriaInformeRespuestas: auditoriaInformeRespuestasCopia,
        },
      });
    },
    async mixEliminarDocumentosEnRespuestasDetalle(store) {
      const { idInforme } = this.$route.params;
      const { idRespuesta } = this;
      const idDetalle = this.detalleDocumentoEliminar.idAuditoriaInformeRespuestaDetalle;
      const idDocumento = this.detalleDocumentoEliminar.id;
      const query = {
        query: AUDITORIA_INFORME_RESPUESTAS,
        variables: { idInforme },
      };
      const { auditoriaInformeRespuestas } = store.readQuery(query);
      const auditoriaInformeRespuestasCopia = auditoriaInformeRespuestas.slice();
      const respuestaEncontrada = auditoriaInformeRespuestasCopia
        .find(({ id }) => id === idRespuesta);
      // Buscar el detalle específico y actualizar el documento
      const detalleEncontrado = respuestaEncontrada.detalles
        .find(({ id }) => id === idDetalle);
      // Eliminar Documento de la lista en el detalle encontrado
      let index = detalleEncontrado.documentos
        .findIndex((a) => a.id === idDocumento);
      if (index !== -1) {
        detalleEncontrado.documentos
          .splice(index, 1);
      }
      index = auditoriaInformeRespuestasCopia
        .findIndex(({ id }) => id === respuestaEncontrada.id);
      if (index !== -1) {
        auditoriaInformeRespuestasCopia.splice(index, 1, respuestaEncontrada);
      }
      store.writeQuery({
        ...query,
        data: {
          auditoriaInformeRespuestas: auditoriaInformeRespuestasCopia,
        },
      });
    },
  },
};
